// Price tokens like {{item:Refrigerator}} in site copy are filled from Admin > Pricing (Item Calculator + load tiers).
import PRICING_DEFAULTS from "./pricingDefaults.json";

const PT_RE = /\{\{(\w+)(?::([^}]+))?\}\}/g;
const ptUsd = (n) => "$" + (Number.isInteger(n) ? n : Number(n).toFixed(2));
const ptCurb = (p, d) => Math.round(p * (1 - d / 100));

const ptFind = (pr, name) => {
  const key = name.trim().toLowerCase();
  for (const c of pr.calcItems || []) for (const it of c.items) if (it.name.toLowerCase() === key) return { curb: it.curbside, full: it.full };
  for (const c of pr.calcItems || []) for (const it of c.items) if (it.name.toLowerCase().startsWith(key)) return { curb: it.curbside, full: it.full };
  for (const c of pr.perItem || []) for (const [n, v] of c.items) if (n.toLowerCase() === key) return { curb: null, full: parseFloat(String(v).replace(/[^0-9.]/g, "")) };
  return null;
};

const ptSum = (pr, spec) => {
  let curb = 0, full = 0;
  for (const n of spec.split("+")) {
    const it = ptFind(pr, n) || ptFind(PRICING_DEFAULTS, n);
    if (!it) return null;
    curb = curb === null || it.curb === null ? null : curb + it.curb;
    full += it.full;
  }
  return { curb, full };
};

export function priceToken(pr, kind, arg) {
  const d = pr.curbsideDiscount ?? 30;
  const t = pr.tiers && pr.tiers.length ? pr.tiers : PRICING_DEFAULTS.tiers;
  const tier = (i) => (t[i] || t[t.length - 1]).price;
  if (kind === "disc") return String(d);
  if (kind === "min") return ptUsd(ptCurb(tier(0), d));
  if (kind === "minFull") return ptUsd(tier(0));
  if (kind === "fullLoad") return ptUsd(tier(t.length - 1));
  if (kind === "fullLoadCurb") return ptUsd(ptCurb(tier(t.length - 1), d));
  if (kind === "tier") return ptUsd(tier(+arg));
  if (kind === "tierCurb") return ptUsd(ptCurb(tier(+arg), d));
  if (kind.startsWith("item")) {
    const it = ptSum(pr, arg || "");
    if (!it) return "a quoted price";
    if (kind === "itemFull" || it.curb === null) return ptUsd(it.full);
    if (kind === "itemCurb") return ptUsd(it.curb);
    return `${ptUsd(it.curb)} curbside / ${ptUsd(it.full)} full-service`;
  }
  return null;
}

export const fillPrices = (s, pr) => s.replace(PT_RE, (m, k, a) => priceToken(pr, k, a) ?? m);

export const applyPrices = (o, pr) => {
  if (typeof o === "string") return fillPrices(o, pr);
  if (Array.isArray(o)) return o.map((x) => applyPrices(x, pr));
  if (o && typeof o === "object" && !o.$$typeof && Object.getPrototypeOf(o) === Object.prototype)
    return Object.fromEntries(Object.entries(o).map(([k, v]) => [k, applyPrices(v, pr)]));
  return o;
};
